export const buildQueryString = (
  experiments?: string[],
  successType?: string,
  showEmbeddedCheckout?: boolean,
  urlParams?: URLSearchParams,
) => {
  const donateUrlParams = new URLSearchParams();

  const trimmedSuccessType = successType?.trim();
  const trimmedExperiments = experiments
    ?.map(e => e.trim())
    .filter(e => e !== '');

  if (
    trimmedExperiments &&
    trimmedExperiments.length > 0 &&
    trimmedSuccessType
  ) {
    donateUrlParams.append('experiments', trimmedExperiments.join(','));
    donateUrlParams.append('successType', trimmedSuccessType);
  }

  if (showEmbeddedCheckout) {
    donateUrlParams.append('checkoutMode', 'Headless');
  }

  const utmSource = urlParams?.get('utm_source');
  if (utmSource) {
    donateUrlParams.append('reference', utmSource);
  }

  return donateUrlParams.toString() ? `?${donateUrlParams.toString()}` : '';
};
